import React, { useState } from 'react';

import * as actions from '../redux/actions';
import * as serviceActions from '../../pb-service-list/redux/actions';
import * as commonActions from '../../common/redux/actions';
import * as myAccountActions from '../my-account/redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';
import HeroSection from '../common/HeroSection/HeroSection';
import TarapacaSearchBox from './common/TarapacaSearchBox';
import TarapacaTitle from './common/TarapacaTitle';
import TarapacaSlider from './common/TarapacaSlider';
import TarapacaIconsSection from './common/TarapacaIconsSection';
import TarapacaAboutUs from './common/TarapacaAboutUs';
import TarapacaTnCSection from './common/TarapacaTnCSection';
import TarapacaContactSection from './common/TarapacaContactSection';
import TarapacaOfficeSection from './common/TarapacaOfficeSection';
// import {
// 	TarapacaAboutUs,
// 	TarapacaContactSection,
// 	TarapacaIconsSection,
// 	TarapacaOfficeSection,
// 	TarapacaSlider,
// 	TarapacaTitle,
// 	TarapacaTnCSection,
// } from './common';
import { withTranslation } from 'react-i18next';
import CommonSearchBox from '../common/search-box/CommonSearchBox';
// import CommonService from '../../../../services/commonService';
const VideoPlayer = () => {
	return (
		<video
			data-permitted-user="true"
			data-resource-title="banner-video.mp4"
			data-resource-uuid="ed6f76a3-fda9-45e6-a846-6db0c99bdfda"
			autoPlay
			muted
			loop
			playsinline="playsinline"
			poster="/assets/tarapaca/Banner Buses tarapacá.png"
			style={{ width: '100%', marginBottom: 30 }}
		>
			<source src="/assets/tarapaca/banner-video.mp4" type="video/mp4; codecs=hevc" />
			<source src="/assets/tarapaca/banner-video.webm" type="video/webm" />
			<source src="/assets/tarapaca/banner-video.mp4" type="video/mp4" />
		</video>
	);
};

const Tarapaca = props => {
	const { history, operator } = props;
	const getFeaturesTitle = () => {

		if (operator && operator.operator_name === 'tarapaca') {
			return 'Servicio';
		}

	};

	const titleLineAlign = () => {
		if (operator && operator.operator_name === 'tarapaca') {
			return true;
		}
		// return tru
	};
	return (
		<div className="theme-two">
			<div style={{ position: 'relative' }}>
				{
					<VideoPlayer />
				}
				<div style={styles.searchBoxOverlay}>
					<CommonSearchBox history={history} operator={operator} />
				</div>
			</div>
			<TarapacaTitle
				operator={operator}
				containerStyle={{ marginBottom: '-10px' }}
				id={'buses'}
				smallHeading={operator.operator_name === "biaggini" ? "Nuestros destinos" : "Destinos"}
				rightLine
			/>

			<TarapacaSlider operator={operator} slides={getSlides('Destination', operator)} />



			<TarapacaTitle
				operator={operator}
				id={'features'}
				smallHeading={getFeaturesTitle()}
				leftLine={!titleLineAlign()}
				rightLine={titleLineAlign()}
			/>


			<TarapacaIconsSection operator={operator} />

			{operator && operator.operator_name === 'tarapaca' && (
				<TarapacaTitle
					operator={operator}
					id={'company'}
					smallHeading=" Nuestra empresa"
					rightLine
					containerStyle={{ marginTop: 70, marginBottom: -40 }}
				/>
			)}
			<TarapacaAboutUs operator={operator} />
			<TarapacaTitle operator={operator} id={'office'} smallHeading="Oficinas" rightLine />
			<TarapacaOfficeSection operator={operator} />
			{(operator && operator.operator_name === 'kennybus') ||
				operator.operator_name === 'jetsur' ||
				operator.operator_name === 'combarbala' ||
				operator.operator_name === 'expresosantacruz' ||
				operator.operator_name === 'barriaghisoni' ||
				operator.operator_name === 'biaggini' ||
				operator.operator_name === 'santamaria' ? (
				<React.Fragment>
					<TarapacaTitle
						operator={operator}
						id={operator.operator_name === 'santamaria' || 'biaggini' ? "terms" : 'passenger'}
						smallHeading={operator.operator_name === 'santamaria' || 'biaggini' ? "Términos y condiciones" : "Obligaciones de los pasajeros"}
						leftLine
					/>

					<TarapacaTnCSection operator={operator} />
				</React.Fragment>
			) : (
				<React.Fragment>
					<TarapacaTitle
						operator={operator}
						containerStyle={{ marginBottom: '-10px' }}
						id={'gallery'}
						smallHeading="Galería"
						rightLine
					/>
					<TarapacaSlider operator={operator} slides={getSlides('Gallery', operator)} />
				</React.Fragment>
			)}
			{operator && operator.operator_name === 'viatur' ? (
				<React.Fragment>
					<TarapacaTitle
						operator={operator}
						id={'privacy'}
						// smallHeading="Políticas de privacidad"
						smallHeading="Obligaciones de los pasajeros"
					// rightLine
					/>
					<PrivacyPolicy operator={operator} />
				</React.Fragment>
			) : null}
			{operator && operator.operator_name === 'cormarbus' ? (
				<React.Fragment>
					<TarapacaTitle
						operator={operator}
						id={'terms'}
						// smallHeading="Políticas de privacidad"
						smallHeading="Términos y condiciones"
					// rightLine
					/>
					<Tnc operator={operator} />
				</React.Fragment>
			) : null}
			<TarapacaTitle operator={operator} id={'contact'} smallHeading="Contacto" rightLine />
			<TarapacaContactSection operator={operator} actions={props.actions} history={history} />
		</div>
	);
};
/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}
const styles = {
	searchBoxOverlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		// top: 0,
		top: '50px',
		zIndex: 10,
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	privacyBtnContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	privacyBtn: {
		fontWeight: '500',
		fontSize: '20px',
		fontColor: '#000000',
		borderBottom: '2px solid black',
	},
	privacyCloseIconContainer: { width: '25px', marginLeft: 'auto' },
	privacyCloseIcon: {
		marginBottom: '-50px',
		cursor: 'pointer',
	},
};
// export default connect(mapStateToProps, mapDispatchToProps)(Tarapaca);
/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
	};
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...serviceActions,
				...myAccountActions,
				...commonActions,
			},
			dispatch,
		),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(Tarapaca));
const Tnc = ({ operator }) => {
	const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
	const createMarkup = data => {
		return { __html: data };
	};
	return (
		<div className="themes-theme-two-about-us new-container" style={{ marginTop: -10 }}>
			<div
				className="lh-1-3 justify-text about"
				style={{
					flex: 1,
					background: operator && operator.color_codes && operator.color_codes.bg_color,
					color: operator && operator.color_codes && operator.color_codes.tertiary_text_color,
				}}
			>
				<div
					dangerouslySetInnerHTML={createMarkup(operator && operator.terms ? operator.terms : '')}
				/>
				<div style={styles.privacyBtnContainer}>
					{!showPrivacyPolicy ? (
						<a style={styles.privacyBtn} onClick={() => setShowPrivacyPolicy(!showPrivacyPolicy)}>
							Ver más
						</a>
					) : (
						<div style={styles.privacyCloseIconContainer}>
							<img
								style={styles.privacyCloseIcon}
								src={getIcons('close2', operator)}
								onClick={() => setShowPrivacyPolicy(false)}
							/>
						</div>
					)}
				</div>
				{showPrivacyPolicy && (
					<div
						style={{ marginTop: '50px' }}
						dangerouslySetInnerHTML={createMarkup(
							operator && operator.privacy_policy ? operator.privacy_policy : '',
						)}
					/>
				)}
			</div>
		</div>
	);
};
const PrivacyPolicy = ({ operator }) => {
	const createMarkup = data => {
		return { __html: data };
	};
	return (
		<div className="themes-theme-two-about-us new-container" style={{ marginTop: -10 }}>
			<div
				className="lh-1-3 justify-text about"
				style={{
					flex: 1,
					background: operator && operator.color_codes && operator.color_codes.primary_color,
					color: operator && operator.color_codes && operator.color_codes.tertiary_text_color,
				}}
			>
				<div
					dangerouslySetInnerHTML={createMarkup(
						operator && operator.privacy_policy ? operator.privacy_policy : '',
					)}
				/>

			</div>
		</div>
	);
};


// WEBPACK FOOTER //
// ./src/features/themes/Tarapaca/Tarapaca.js